import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b770c44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "message-room bg-white border-bottom border-outline-color p-3" }
const _hoisted_5 = { class: "d-flex justify-content-end align-items-center w-100" }
const _hoisted_6 = { class: "flex-grow-1 d-flex flex-column justify-content-between" }
const _hoisted_7 = { class: "office-info" }
const _hoisted_8 = { class: "office-name-label text-size-14 text-weight-500" }
const _hoisted_9 = {
  key: 0,
  class: "text-mild text-size-12 mt-1"
}
const _hoisted_10 = { class: "notification flex-shrink-0 d-flex flex-column justify-content-between align-items-end" }
const _hoisted_11 = { class: "last-message-at-label text-mild text-size-12 ml-3" }
const _hoisted_12 = { class: "arrow flex-shrink-0" }
const _hoisted_13 = {
  key: 1,
  class: "p-3 m-3 bg-white text-size-14 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessagesNav = _resolveComponent("MessagesNav")!
  const _component_CantUseFeature = _resolveComponent("CantUseFeature")!
  const _component_MuteOnSvg = _resolveComponent("MuteOnSvg")!
  const _component_AppBadge = _resolveComponent("AppBadge")!
  const _component_BBadge = _resolveComponent("BBadge")!
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_PullToRefresh = _resolveComponent("PullToRefresh")!
  const _component_AppFooter = _resolveComponent("AppFooter")!
  const _component_BlockBack = _resolveComponent("BlockBack")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_MessagesNav, {
      unreadMessageCount: _ctx.unreadMessageCount,
      unreadInformationCount: _ctx.unreadInformationCount
    }, null, 8, ["unreadMessageCount", "unreadInformationCount"]),
    _createTextVNode(),
    (_ctx.initialized && !_ctx.canApplyOrHasApplications)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_CantUseFeature)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_PullToRefresh, {
            onPull: _ctx.pullToFetchMessages,
            isShowingPullToRefreshLoading: _ctx.isShowingPullToRefreshLoading
          }, {
            default: _withCtx(() => [
              (_ctx.messageRooms.length > 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageRooms, (messageRoom) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: 'room-' + messageRoom.officeId
                      }, [
                        _createVNode(_component_RouterLink, {
                          to: {
                name: 'MessageRoomDetail',
                params: { officeId: messageRoom.officeId }
              }
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("p", _hoisted_8, _toDisplayString(messageRoom.officeName), 1),
                                    _createTextVNode(),
                                    (messageRoom.isMutedOffice)
                                      ? (_openBlock(), _createBlock(_component_MuteOnSvg, {
                                          key: 0,
                                          class: "mute-on-icon"
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createTextVNode(),
                                  (messageRoom.startNextWorkAt)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.getNextWorkLabel(messageRoom)), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.toDisplayTime(messageRoom.lastMessageAt)), 1),
                                  _createTextVNode(),
                                  (messageRoom.unreadCount > 0)
                                    ? (_openBlock(), _createBlock(_component_AppBadge, {
                                        key: 0,
                                        variant: "red",
                                        class: "flex-shrink-0"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(messageRoom.unreadCount), 1)
                                        ], undefined, true),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(),
                                  (messageRoom.requireReply)
                                    ? (_openBlock(), _createBlock(_component_BBadge, {
                                        key: 1,
                                        pill: "",
                                        variant: "primary",
                                        class: "flex-shrink-0 text-weight-400 ml-3 mt-1"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("要挨拶")
                                        ], undefined, true),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_12, [
                                  _createVNode(_component_FeatherIcon, {
                                    icon: "chevron-right",
                                    size: "1x",
                                    class: "text-gray-05 ml-2"
                                  })
                                ])
                              ])
                            ])
                          ], undefined, true),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("p", _hoisted_13, "\n          まだメッセージはありません\n        "))
            ], undefined, true),
            _: 1
          }, 8, ["onPull", "isShowingPullToRefreshLoading"])
        ])),
    _createTextVNode(),
    _createVNode(_component_AppFooter),
    _createTextVNode(),
    _createVNode(_component_BlockBack)
  ]))
}